import { render } from "./DefaultServiceManager.vue?vue&type=template&id=87df18e0&scoped=true"
import script from "./DefaultServiceManager.vue?vue&type=script&lang=js"
export * from "./DefaultServiceManager.vue?vue&type=script&lang=js"

import "./DefaultServiceManager.vue?vue&type=style&index=0&id=87df18e0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87df18e0"]])

export default __exports__